import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "material-ui/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FlatButton from "material-ui/FlatButton";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  }
});

export default class FormDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleCreateTask = () => {
    // console.log({title:this.state.title, dueDate: this.state.dueDate, details: this.state.details})
    if (!this.state.title || !this.state.dueDate || !this.state.details) {
      alert("You must fill out every field.");
    } else {
      this.props.createTask({
        title: this.state.title,
        dueDate: this.state.dueDate,
        details: this.state.details
      });
      this.setState({ open: false, title: "", dueDate: "", details: "" });
      alert("Task Created!");
    }
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  render() {
    return (
      <div style={{ textAlign: "center" }}>
        <br />
        <FlatButton
          backgroundColor="#90caf9"
          containerElement="label"
          label={"Create Task"}
          fullWidth={true}
          labelStyle={{ fontSize: 11 }}
          onClick={this.handleClickOpen}
        />
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Create New Task</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Be sure to fill out all the fields.
            </DialogContentText>
            <TextField
              margin="dense"
              id="name"
              label="Task Title"
              type="text"
              onChange={e => this.setState({ title: e.target.value })}
            />
            <br />
            <TextField
              margin="dense"
              id="name"
              label="Due Date"
              type="text"
              onChange={e => this.setState({ dueDate: e.target.value })}
            />
            <TextField
              margin="dense"
              id="name"
              label="Details"
              type="text"
              fullWidth
              onChange={e => this.setState({ details: e.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleCreateTask} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/project/project_dialog.js